export default function ($q, lodash, ErrorHandlerFactory) {
    const DEFAULT_CURRENT_PAGE = 1;
    const DEFAULT_PER_PAGE = 20;

    const defaultProcessQuery = (list, query) => lodash.extend({}, query, { sort: list.sort });
    const defaultProcessResults = (list, data) => data;

    const create = ($request, processQuery = defaultProcessQuery, processResults = defaultProcessResults) => {
        const list = {
            items: [],
            loading: false,
            lastQuery: {},
            lastPostParameters: {},
            sort: undefined,
            sortBy: (field) => {
                const ASC = `${field}`;
                const DESC = `-${field}`;
                if (list.sort === ASC) {
                    list.sort = DESC;
                }
                else if (list.sort === DESC) {
                    list.sort = ASC;
                }
                else {
                    list.sort = ASC;
                }
                list.fetch();
            },
            fetch: (query = list.lastQuery, PostParameters = list.lastPostParameters) => {
                list.errors = {};
                list.invalid = false;
                list.loading = true;
                list.lastQuery = processQuery(list, query);
                list.lastPostParameters = PostParameters;
                return $request(list.lastQuery, PostParameters, (data, headers) => {
                    list.items = processResults(list, data, headers);
                    list.loading = false;
                })
                .$promise
                .catch((response) => {
                    list.invalid = true;
                    list.loading = false;
                    list.errors = ErrorHandlerFactory.parseFormErrors(response);
                    return $q.reject(response);
                });
            },
            getSortClass (field) {
                let sortClass = 'sorting';
                if (this.sort === field) {
                    sortClass = 'sorting_asc';
                }
                else if (this.sort === `-${field}`) {
                    sortClass = 'sorting_desc';
                }
                return sortClass;
            }
        };
        return list;
    };

    return {
        create,
        createWithPagination: ($request) => {
            const processQuery = (list, query) => {
                const defaultQuery = defaultProcessQuery(list, query);
                const page = lodash.get(query, 'currentPage', list.pagination.currentPage);
                const pageSize = lodash.get(query, 'pageSize', list.pagination.perPage);
                return lodash.extend({}, defaultQuery, { page, pageSize });
            };
            const processResults = (list, results, headers) => {
                const parseIntHeaders = header => parseInt(headers(header), 10);
                lodash.set(list, 'pagination.currentPage', parseIntHeaders('x-pagination-current-page'));
                lodash.set(list, 'pagination.pageCount', parseIntHeaders('x-pagination-page-count'));
                lodash.set(list, 'pagination.perPage', parseIntHeaders('x-pagination-per-page'));
                lodash.set(list, 'pagination.totalCount', parseIntHeaders('x-pagination-total-count'));
                return results;
            };
            const list = create($request, processQuery, processResults);
            list.pagination = {
                currentPage: DEFAULT_CURRENT_PAGE,
                perPage: DEFAULT_PER_PAGE,
                pageCount: 1,
                totalCount: 1
            };
            return list;
        },
        createWithoutPagination: ($request) => {
            const processQuery = (list, query) => {
                const defaultQuery = defaultProcessQuery(list, query);

                return lodash.extend({}, defaultQuery, { pageSize: 0 });
            };
            return create($request, processQuery);
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/factories/list/index.js